import "./title-section.css";

/**
 * @param {object} props
 * @param {string} props.title
 * @param {1|2} [props.headingLevel=2] Use 1 for the main page title (single H1 per view). Default 2 for section titles (e.g. home carousels).
 */
function TitleSection({ title, headingLevel = 2 }) {
  const normalizeBlueTitle = (value) => {
    const text = String(value || "").trim();
    if (!text) {
      return "";
    }
    const onlyLetters = text.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g, "");
    const isMostlyUpper =
      onlyLetters.length > 0 && onlyLetters === onlyLetters.toUpperCase();

    if (!isMostlyUpper) {
      return text;
    }

    return text
      .toLocaleLowerCase("es-MX")
      .replace(/\b([a-záéíóúüñ])/g, (m) => m.toLocaleUpperCase("es-MX"));
  };

  const HeadingTag = headingLevel === 1 ? "h1" : "h2";

  return (
    <>
      <div className="title-section">
        <div className="title-section__container">
          <div className="title-section__content">
            <HeadingTag className="title-section__heading">
              {normalizeBlueTitle(title)}{" "}
            </HeadingTag>
          </div>
        </div>
      </div>
    </>
  );
}

export default TitleSection;
